import { render, staticRenderFns } from "./classselect.vue?vue&type=template&id=3e2d37e4"
import script from "./classselect.vue?vue&type=script&lang=js"
export * from "./classselect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports